import ImageBasic from "../../Common/Image/ImageBasic";
import IMG from "../../../constants/image";
import React from "react";
import {text} from "../../../constants/text";

const HeaderForm = () => (
        <div className='flex text-sm font-bold space-x-2 items-center justify-center py-[10px] pt-6 md:pt-0'>
            <ImageBasic src={IMG.icon.document}/>
            <div>{text.confirmOrder}</div>
        </div>
    )
;
export default HeaderForm;